import { render, staticRenderFns } from "./browseRecords.vue?vue&type=template&id=3a33ee64&scoped=true&"
import script from "./browseRecords.vue?vue&type=script&lang=js&"
export * from "./browseRecords.vue?vue&type=script&lang=js&"
import style0 from "./browseRecords.vue?vue&type=style&index=0&id=3a33ee64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33ee64",
  null
  
)

export default component.exports